import {Component} from "../Component";
import {inject} from "../../services/di";
import {element} from "../CustomElement";
import {i18n} from "../../i18n/I18n";
import {icons} from "../../icons/Icons";
import Glide, { Controls, Autoplay, Swipe } from "@glidejs/glide/dist/glide.modular.esm";

import {ConfigService} from "../../services/ConfigService";
import {LocationService} from "../../services/LocationService";
import {UserAgentService} from "../../services/UserAgentService";
import {BlackFridayService} from "../../services/BlackFridayService";
import {Link} from "../flipp-link/Link";
import {DateTimeService} from "../../services/DateTimeService";

@element("black-friday-banner")
export class BlackFridayBanner extends Component<{}, {}> {
	@inject config: ConfigService;
	@inject location: LocationService;
	@inject userAgent: UserAgentService;
	@inject bf: BlackFridayService;
	@inject dateService: DateTimeService;

	glide: any;

	refs: {
		bfBannerControl: HTMLButtonElement;
		gaBannerControl: HTMLButtonElement;
	};

	onRender() {
		if (this.bf.isBlackFridayGiveawayPeriod()) {
			setTimeout(() => {
				this.glide = new Glide(".glide", {
					autoplay: 10000,
					rewind: true,
					animationTimingFunc: "ease-in-out",
					animationDuration: 750,
					rewindDuration: 750
				}).mount({ Controls, Autoplay, Swipe });

				this.glide.on(["swipe.start", "move"], () => {
					this.updateControlView();
				});
			});
		}
	}

	renderBFBanner() {
		const textClassAppendix = this.location.locale === "fr-ca" ? " french" : "";
		const bfClassAppendix = this.bf.isOnHost() ? " bf" : "";
		const textClass = "blackfriday-banner__title" + textClassAppendix + bfClassAppendix;
		return (
			<div class="blackfriday-banner">
				<div class={textClass}>
					{this.bf.isCyberWeekPeriod() ? i18n("cyberweek_banner_title") : i18n("blackfriday_banner_title")}
				</div>
				<div class="blackfriday-banner__more">
					{!this.bf.isOnHost() ? this.renderButton() : null}
				</div>
			</div>
		);
	}

	renderGiveawayBanner() {
		return (
			<div class="giveaway-banner">
				<div class="giveaway-banner__title">
					{i18n("giveaway_banner_title")}
				</div>
				<div class="giveaway-banner__subtitle">
					{i18n("giveaway_banner_subtitle")}
				</div>
				<div class="giveaway-banner__date">
					{i18n("giveaway_banner_date")}
				</div>
				<a href={this.bf.getGiveawayLink()} target="_blank" class="giveaway-banner__button">
					{i18n("giveaway_banner_button_text")}
					{icons.rightArrow}
				</a>
			</div>
		);
	}

	updateControlView() {
		if (this.glide.index === 0) {
			this.refs.bfBannerControl.classList.add("filled");
			this.refs.bfBannerControl.classList.remove("empty");

			this.refs.gaBannerControl.classList.add("empty");
			this.refs.gaBannerControl.classList.remove("filled");
		} else {
			this.refs.bfBannerControl.classList.add("empty");
			this.refs.bfBannerControl.classList.remove("filled");

			this.refs.gaBannerControl.classList.add("filled");
			this.refs.gaBannerControl.classList.remove("empty");
		}
	}

	render() {
		return this.bf.isBlackFridayGiveawayPeriod() ? <div class="glide">
					<div class="glide__track" data-glide-el="track">
						<ul class="glide__slides">
							<li class="glide__slide">
								{this.renderBFBanner()}
							</li>
							<li class="glide__slide">
								{this.renderGiveawayBanner()}
							</li>
						</ul>
					</div>
					<div class="bullets-container" onClick={this.updateControlView.bind(this)} >
						<div class="glide__bullets" data-glide-el="controls[nav]">
							<button ref="bfBannerControl"  class="glide__bullet filled" data-glide-dir="=0"/>
							<button ref="gaBannerControl" class="glide__bullet empty" data-glide-dir="=1"/>
						</div>
					</div>

				</div> : this.renderBFBanner();
	}

	renderButton() {
		const textClassAppendix = this.location.locale === "fr-ca" ? " french" : "";
		const textClass = "flipp-button" + textClassAppendix;
		return (
			<Link class={textClass} to="blackFriday">
				{this.bf.isCyberWeekPeriod() ? i18n("cyberweek_deals") : i18n("blackfriday_deals") }
			</Link>
		);
	}

}
